module.exports = __webpack_public_path__ + "img/s4.34f38566.svg";